import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

import PromptsService, { TestQueryDto } from '@/services/PromptsService';

export function useTestQuery() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (testQueryDto: TestQueryDto) =>
      PromptsService.testQuery(testQueryDto),
    onError: (error) => {
      const errorMessage =
        error instanceof AxiosError
          ? error?.response?.data?.message
          : 'Erro ao testar query';
      toast.error(errorMessage);
    },
  });

  return {
    testQuery: mutateAsync,
    isTestingQuery: isPending,
  };
}
